 
const visileColumns = [
  
  {
    title: "ID",
    field: "ID",
    locked: false,
    filter: "text",
    width: 160,
    show: true,
  },
  // {
  //   title: "Subscriber Id",
  //   field: "SubscriberID",
  //   locked: false,
  //   filter: "text",
  //   width: 200,
  //   show: true,
  // },
  {
    title: "Template Name",
    field: "TemplateName",
    locked: false,
    filter: "text",
    width: 200,
    show: true,
  },
  {
    title: "Process Name",
    field: "ProcessName",
    locked: false,
    filter: "text",
    width: 200,
    show: true,
  },
  {
    title: "Status Name",
    field: "StatusName",
    locked: false,
    filter: "text",
    width: 300,
    show: true,
  },
  {
    title: "Email",
    field: "Email",
    locked: false,
    filter: "text",
    width: 150,
    show: true,
  },
  {
    title: "Dashboard",
    field: "Dashboard",
    locked: false,
    filter: "text",
    width: 150,
    show: true,
  },
  {
    title: "NonAction Required",
    field: "NonActionRequired",
    locked: false,
    filter: "text",
    width: 300,
    show: true,
  },
  {
    title: "Action Required",
    field: "ActionRequired",
    locked: false,
    filter: "text",
    width: 300,
    show: true,
  },
  
  
  
];

export default visileColumns;
